import api from './api';

export default class AvaliacaoService {
  constructor() {
    throw 'Não é possível instanciar AvaliacaoService';
  }

  static async obtem(id) {
    const endpoint = mergeEndpoint(id);
    return await api.get(endpoint);
  }

  static async atualiza(id, item) {
    const endpoint = mergeEndpoint(id);
    return await api.put(endpoint, item);
  }
}

const mergeEndpoint = id => {
  return `avaliacoes-periodicas/${id}`;
};



// WEBPACK FOOTER //
// ./src/services/avaliacaoService.js